import { render, staticRenderFns } from "./TabbedContainerComponent.vue?vue&type=template&id=bd7d6478&scoped=true"
import script from "./TabbedContainerComponent.vue?vue&type=script&lang=js"
export * from "./TabbedContainerComponent.vue?vue&type=script&lang=js"
import style0 from "./TabbedContainerComponent.vue?vue&type=style&index=0&id=bd7d6478&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7d6478",
  null
  
)

export default component.exports